import {PrescriptionSetDto} from '../types/prescription';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import prescriptionsApi from '../api/prescriptions/prescriptionsApi';
import {RootState} from './store';
import { ReferralResponseDto } from '../types/referrals';
import { referralApi } from '../api/referral/referralApi';

const sliceName = 'referralSlice';
type ReferralStatusType = 'idle' | 'loading' | 'failed';

const initialState = {
    referrals: [] as ReferralResponseDto[],
    status: 'idle' as ReferralStatusType,
};

export const fetchReferrals = createAsyncThunk<
    ReferralResponseDto[],
    {appointmentId: number},
    unknown
>(`${sliceName}/fetchReferrals`, async ({appointmentId}) => {
    try {
        const {data} = await referralApi.getReferrals(appointmentId);
        return data?.result;
    } catch (err) {
        console.error(err);
    }
});

const referralSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchReferrals.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchReferrals.fulfilled, (state, action) => {
                state.status = 'idle';
                state.referrals = action.payload;
            })
            .addCase(fetchReferrals.rejected, state => {
                state.status = 'failed';
            });
    },
});

export const selectReferrals = (state: RootState) =>
    state.referral.referrals;

export const selectReferralsStatus = (state: RootState) =>
    state.referral.status;

export default referralSlice.reducer;
